import React from 'react';
import './contact.css';

import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { useContactGsapAnimation } from './useContactGsapAnimation';
import { useState } from 'react';

export default function ContactForm() {
  const { formRef, headerRef } = useContactGsapAnimation();
  const [phone, setPhone] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    message: '',
    agree: false,
  });
  const [status, setStatus] = useState(null);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('http://localhost:5001/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.firstName + ' ' + form.lastName,
          email: form.email,
          phone,
          company: form.company,
          message: form.message,
        }),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ firstName: '', lastName: '', company: '', email: '', message: '', agree: false });
        setPhone('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div id="contact">
      <div aria-hidden="true" className="contact-bg-blur">
        <div className="contact-bg-shape" />
      </div>

      <div className="contact-header" ref={headerRef}>
        <h2>Contact Us</h2>
        <p>
          Reach out to us for partnership, support, or any questions about IROD. We’re here to help you protect wildlife and deploy smart conservation technology.<br/>
          <strong>Email:</strong> <a href="mailto:info@visyntech.co.zw">info@visyntech.co.zw</a><br/>
          <strong>Phone:</strong> +263 77 123 4567, +263 71 234 5678
        </p>
      </div>

      <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
        <div className="contact-grid">
          <div>
            <label htmlFor="first-name">First name</label>
            <input id="first-name" name="firstName" type="text" autoComplete="given-name" value={form.firstName} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="last-name">Last name</label>
            <input id="last-name" name="lastName" type="text" autoComplete="family-name" value={form.lastName} onChange={handleChange} required />
          </div>
          <div className="full-width">
            <label htmlFor="company">Organisation</label>
            <input id="company" name="company" type="text" autoComplete="organization" value={form.company} onChange={handleChange} />
          </div>
          <div className="full-width">
            <label htmlFor="email">Email</label>
            <input id="email" name="email" type="email" autoComplete="email" value={form.email} onChange={handleChange} required />
          </div>
          <div className="full-width">
            <label htmlFor="phone-number">Phone number</label>
            <input
              id="phone-number"
              name="phone"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              required
              placeholder="Enter phone number (any format)"
              pattern="[+()0-9\s-]{7,}"
              autoComplete="tel"
            />
          </div>
          <div className="full-width">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" rows={4} value={form.message} onChange={handleChange} required />
          </div>
          <div className="policy-check full-width">
            <div className="checkbox-wrapper">
              <input id="agree-to-policies" name="agree" type="checkbox" checked={form.agree} onChange={handleChange} required />
            </div>
            <label htmlFor="agree-to-policies">
              By selecting this, you agree to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a>.
            </label>
          </div>
        </div>
        <div className="submit-wrapper">
          <button type="submit" disabled={status === 'sending'}>Let's talk</button>
        </div>
        {status === 'success' && <div className="form-success">Thank you! We'll be in touch soon.</div>}
        {status === 'error' && <div className="form-error">Something went wrong. Please try again.</div>}
      </form>
    </div>
  );
}
